import { useMessages, useBlockTheme } from "@quillforms/renderer-core";

/**
 * WordPress Dependencies
 */
import { useEffect } from "react";

/**
 * External Dependencies
 */
import tinyColor from "tinycolor2";
import { css } from "emotion";
import classnames from "classnames";


const ShortTextBlock = (props) => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    blockWithError,
    val,
    setVal,
    showErrMsg,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isPreview,
    isReviewing,
    innerBlocks,
  } = props;
  const messages = useMessages();
  const theme = useBlockTheme(attributes.themeId);
  const answersColor = tinyColor(theme.answersColor);

  const {
    minCharacters,
    maxCharacters,
    setMaxCharacters,
    required,
    placeholder,
    nextOnEnter,
    capitalize,
    type,
  } = attributes;

  let skipValidation = false;

  const checkfieldValidation = (value) => {
    if (skipValidation) {
      skipValidation = false;
      return;
    }
    if (required === true && (!value || value === "")) {
      setIsValid(false);
      setValidationErr(messages["label.errorAlert.required"]);
    } else if (
      setMaxCharacters &&
      maxCharacters > 0 &&
      value?.length > maxCharacters
    ) {
      setIsValid(false);
      setValidationErr(messages["label.errorAlert.maxCharacters"]);
    } else if (
      minCharacters !== false &&
      minCharacters > 0 &&
      value?.length < minCharacters
    ) {
      setIsValid(false);
      setValidationErr(messages["label.errorAlert.minCharacters"]);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };

  useEffect(() => {
    if (isPreview || !isReviewing) checkfieldValidation(val);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes]);

  // // Focus on mount
  // useEffect(() => {
  //   if (attributes.focusOnMount && inputRef.current) {
  //     setTimeout(() => {
  //       inputRef.current?.focus();
  //     }, 100);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [attributes.focusOnMount]);

  const changeHandler = (e) => {
    const value = e.target.value;
    if (setMaxCharacters && maxCharacters > 0 && value.length > maxCharacters) {
      blockWithError(messages["label.errorAlert.maxCharacters"]);
    } else {
      setVal(value);
      showErrMsg(false);
      checkfieldValidation(value);
    }
    if (value && value !== "") {
      setIsAnswered(true);
      showNextBtn(true);
    } else {
      setIsAnswered(false);
    }
  };

  return (
    <input
      ref={inputRef}
      className={classnames(
        css`
          & {
            width: 100%;
            border: none !important;
            border-radius: 0 !important;
            outline: none;
            padding-bottom: 8px;
            background: transparent;
            transition: box-shadow 0.1s ease-out 0s;
            box-shadow: ${answersColor.setAlpha(0.3).toString()} 0px 1px !important;
          }

          &::placeholder {
            opacity: 0.3;
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${theme.answersColor};
          }

          &:-ms-input-placeholder {
            opacity: 0.3;
            /* Internet Explorer 10-11 */
            color: ${theme.answersColor};
          }

          &::-ms-input-placeholder {
            opacity: 0.3;
            /* Microsoft Edge */
            color: ${theme.answersColor};
          }

          &:focus {
            box-shadow: ${answersColor.setAlpha(1).toString()} 0px 2px !important;
          }

          color: ${theme.answersColor} !important;
          -webkit-appearance: none;
        `
      )}
      id={"short-text-" + id}
      data-ref={id}
      type={type}
      placeholder={
        placeholder === false
          ? messages["block.shortText.placeholder"]
          : placeholder
      }
      onKeyUp={(e) => {
        if (!capitalize) return;
        const value = e.currentTarget.value;
        e.currentTarget.value = value.charAt(0).toUpperCase() + value.slice(1);
      }}
      onKeyDown={(e) => {
        if (!nextOnEnter) return;
        if (e.key === "Enter") {
          // get the next inner block
          const keys = innerBlocks.map((block) => block.id);
          const index = keys.indexOf(id);
          const nextBlock = innerBlocks[index + 1];
          if (nextBlock) {
            const nextBlockInput = document.getElementById(
              `short-text-${nextBlock.id}`
            );
            nextBlockInput.focus();
            e.stopPropagation();
            skipValidation = true;
          }
        }
      }}
      onChange={changeHandler}
      value={val ? val.toString() : ""}
      onFocus={() => {
        if (isTouchScreen) {
          setFooterDisplay(false);
        }
      }}
      onBlur={() => {
        if (isTouchScreen) {
          setFooterDisplay(true);
        }
      }}
      autoComplete="off"
    />
  );
};

export default ShortTextBlock;
